'use client';

// ============================================================================
// DemoTaskCard — Client-Wrapper um die ECHTE Wochenplan-Aufgabenkarte
// ============================================================================
//
// TaskCardNeu ist sauber props-only und damit das stärkste «Die App ist die
// Landing Page»-Signal — sie wird hier 1:1 wiederverwendet. Der Wrapper
// existiert, weil Funktions-Props (onStart) die Server/Client-Grenze nicht
// überqueren dürfen; der No-op gehört deshalb hierher. Der Eltern-Container
// auf der Landing setzt pointer-events-none — der «Starten»-Button ist
// sichtbar Teil des Produkts, aber kein totes Interaktiv-Element.

import { TaskCardNeu } from '@/components/Wochenplan/TaskCardNeu';
import type { WochenplanTask } from '@/types';

export function DemoTaskCard({ task, isRecommended }: { task: WochenplanTask; isRecommended?: boolean }) {
  return <TaskCardNeu task={task} isRecommended={isRecommended} onStart={() => {}} />;
}
